import { toFullName } from '@repo/toolkit/to-full-name'
import Box from '@repo/ui/box'
import { UserTwoIcon } from '@repo/ui/icons'
import { PropsWithChildren } from 'react'

import { EnrollmentProperties } from '../../../lib/types/models/enrollment/enrollment.properties'
import { EnrollmentLight } from '../../../lib/types/models/enrollment/enrollment-light'
import UserNavBar from '../../elements/nav-bar'
import EnrollmentInformationCard, {
  EnrollmentInformationCardInput
} from './enrollment-information-card'
import OtoIndividualEnrollmentInformationCard, {
  OtoIndividualEnrollmentInformationCardInput
} from './oto-individual-enrollment-information-card'

// the header sits on top of every client space page, so it must be able to describe both a
// journey enrollment and a One to One Individuel one: it carries the fields of both cards and
// picks the card matching the enrollment's proposition type
type Props = {
  enrollment: EnrollmentInformationCardInput &
    OtoIndividualEnrollmentInformationCardInput &
    Pick<EnrollmentLight, 'childFirstName' | 'childLastName'>
}

const ClientSpaceHeaderWrapper = ({ enrollment, children }: PropsWithChildren<Props>) => {
  return (
    <>
      <UserNavBar
        title={toFullName(enrollment.childFirstName, enrollment.childLastName, {
          options: { mode: 'lastname-firstname' }
        })}
        icon={UserTwoIcon}
      />

      <Box className="flex flex-col gap-4 mt-4 " isMobileScrollable>
        {EnrollmentProperties.isOtoIndividual(enrollment) ? (
          <OtoIndividualEnrollmentInformationCard enrollment={enrollment} mode="default" />
        ) : (
          <EnrollmentInformationCard enrollment={enrollment} mode="default" />
        )}
        {children}
      </Box>
    </>
  )
}

export default ClientSpaceHeaderWrapper
